import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import TextInput from '../../inputs/text'

/**
 * Edit Panel - Source: Controls the source url
 * text input in the GIF Edit Panel.
 *
 * @class EditPanelSource
 */
const EditPanelSource = ({ className, value, onChange }) => (
    <div className={className}>
        <span>Source</span>
        <TextInput type="url" value={value} placeholder="Add a source URL" buttonLabel="Save" onSubmit={onChange} />
    </div>
)

EditPanelSource.propTypes = {
    className: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
}

export default EditPanelSource
